import { client, getUrl } from "utils";

export const getPublishRequestsCountRequest = (filterParams) => client.get(getUrl("publish-requests", filterParams))
    .then(({ count }) => ({ [filterParams.id]: count }));

export const getConfigCITestsRequest = (filterParams) => client.get(getUrl("config-ci-test-tasks", filterParams));

export const configCiTestTaskCancelRequest = ({ id, ...data }) => client.patch(`config-ci-test-task/${id}/cancel`, data);

export const getTestCaseRequest = (id) =>
    client.get(`config-ci-test-task/${id}/test-case-tasks`)
        .then(({ config_ci_test_case_tasks }) => ({ [id]: config_ci_test_case_tasks }));
